export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_amzGoodsSkuNo') || '产品SKU编号',
    field: 'amzGoodsSkuNo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzSkuNo') || '亚马逊SKU编号',
    field: 'amzSkuNo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_asinCode') || 'ASIN',
    field: 'asinCode',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fnskuCode') || 'FNSKU',
    field: 'fnskuCode',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandCode',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        placeholder: '请选择',
        url: '/master/common/dict/brandSelect',
        filterable: true,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_salesGoodsName') || '店铺售卖名称',
    field: 'salesGoodsName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: '请输入',
        style: 'width:100%',
      },
    },
  },
  {
    title: that.$l('table_label_salesTitle') || '店铺售卖标题',
    field: 'salesTitle',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: '请输入',
        style: 'width:100%',
      },
    },
  },
  {
    title: that.$l('table_label_salesPrice') || '正常卖价',
    field: 'salesPrice',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: '请输入',
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 4,
      },
    },
  },
  {
    title: that.$l('table_label_salesCurrencyUnit') || '卖价货币单位',
    field: 'salesCurrencyUnit',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        placeholder: '请选择',
        body: { dictType: 'currencyUnit' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_fbaDeliveryFee') || 'FBA配送费',
    field: 'fbaDeliveryFee',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
      events: {
        blur: ({ row, column }) => {
          if (row[column.property] == undefined) {
            row[column.property] = 0
          }
        },
      },
    },
  },
]
